import { BaseLookup } from "./BaseLookup";

export class BettingTip extends BaseLookup {
    sortOrder: number;
    /**
     * Localized display name
     */
    displayName: string;
}